module.exports = {"code":200,"data":{},"msg":"请求成功！"}


//////////////////
// WEBPACK FOOTER
// ./src/opr/static/tsconfig.json
// module id = OVGm
// module chunks = 1